import {
  Control,
  Controller,
  UseFormClearErrors,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import { RulesEngineFormValues } from '../rules-engine-form-page-old';
import SharedProfileFieldFilter from '../../../../shared/shared-profile-field-filter';
import { SectionHeader } from '../../../../shared/section-header';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface AdminFiltersStepProps {
  control: Control<RulesEngineFormValues>;
  watch: UseFormWatch<RulesEngineFormValues>;
  setValue: UseFormSetValue<RulesEngineFormValues>;
  clearErrors: UseFormClearErrors<RulesEngineFormValues>;
}

export default function RulesEngineAdminFiltersStep({
  control,
  watch,
  setValue,
  clearErrors,
}: AdminFiltersStepProps) {
  const hasProfileFieldFilter = watch('hasProfileFieldFilter');
  return (
    <Stack gap={2} width={'100%'}>
      <SectionHeader>
        Admin Filters <span style={{ fontWeight: 400 }}>(optional)</span>
      </SectionHeader>
      <Typography variant="caption">
        You can optionally provide a filter on a user's profile field. This will
        act as an "and" condition with other filters.
      </Typography>
      <Controller
        name="hasProfileFieldFilter"
        control={control}
        render={({ field: props }) => (
          <FormControlLabel
            sx={{ width: 'fit-content' }}
            control={
              <Checkbox
                {...props}
                checked={props.value}
                onChange={(e) => {
                  props.onChange(e.target.checked);
                }}
              />
            }
            label="Filter By Profile Information"
          />
        )}
      />
      <Box sx={{ pl: '16px' }}>
        <SharedProfileFieldFilter
          control={control}
          watch={watch}
          setValue={setValue}
          clearErrors={clearErrors}
          baseFieldName="profileFieldFilter"
          disabled={!hasProfileFieldFilter}
        />
      </Box>
    </Stack>
  );
}
